import axios from "axios";
import { appUrls, endPoints } from "../../constants/urls";
import { MERCHANT_ACCOUNT_UUID, TEST_MERCHANT_ACCOUNT_UUID } from "../../constants/cookieKeys";
import Cookies from 'universal-cookie';
import { isTestMode } from "dashboard-utils";

export const fetchMerchantInfo = () => {
  const cookies = new Cookies();
  const merchantAccountUUID = isTestMode ? cookies.get(TEST_MERCHANT_ACCOUNT_UUID) : cookies.get(MERCHANT_ACCOUNT_UUID);
  return axios({
    method: "GET",
    url: `${appUrls.ORCHESTRATION_LAYER + endPoints.MERCHANT_DETAILS(merchantAccountUUID)}`,
  });
};

export const isOfferMerchant = (params) => {
  return axios({
    method: "POST",
    url: `${appUrls.ORCHESTRATION_LAYER + endPoints.MERCHANT_OFFER_STATUS}`,
    data: params,
    headers: {
      platformid: 1
    }
  });
};

export const fetchUATMID = (params) => {
  const { email, product, uuid } = params;
  return axios({
    method: "POST",
    url: `${appUrls.ORCHESTRATION_LAYER + endPoints.FETCH_UAT_MID(uuid)}`,
  });
}